<template>
  <div class="quiz-translator">
    <collapse accordion>
      <collapse-item title="Desafio Original" actived>
        <div class="columns" v-if="PlaceQuizes['pt'] && PlaceQuizes['pt'].length > 0">
          <div class="column" style="background-color: #efefef">
            <p>
              <b>Título:</b> {{PlaceQuizes['pt'][0].title}}
            </p>
            <p>
              <b>Descrição:</b> {{PlaceQuizes['pt'][0].description}}
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column"><hr /></div>
        </div>
        <div class="columns">
          <div class="column">
            <h4 class="is-title">Traduzir para <b>{{lang}}</b>:</h4>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div v-if="PlaceQuizes[lang] && PlaceQuizes[lang].length > 0">
              <p>
                <b>Título:</b> {{PlaceQuizes[lang][0].title}}
              </p>
              <p>
                <b>Descrição:</b> {{PlaceQuizes[lang][0].description}}
              </p>
            </div>
            <quiz-form
              :is-loading="isMainFormLoading"
              :is-disabled="isMainFormDisabled"
              button-label="Salvar tradução"
              :on-submit="save"
              v-else
            />
          </div>
        </div>
      </collapse-item>
      <collapse-item
        title="Perguntas"
        v-show="PlaceQuizes[lang] && PlaceQuizes[lang].length > 0"
      >
        <div v-if="PlaceQuizes['pt'] && PlaceQuizes['pt'].length > 0">
          <div v-for="(a, index) in PlaceQuizes['pt'][0].answers" :key="index">
            <div class="columns" style="background-color: #efefef">
              <div class="column">
                <p><b>Texto: </b>{{a.text}}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <h4 class="is-title">Traduzir para <b>{{lang}}</b>:</h4>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div
                  v-if="
                    PlaceQuizes[lang]
                    && PlaceQuizes[lang].length > 0
                  "
                >
                  <p v-if="PlaceQuizes[lang][0].answers && PlaceQuizes[lang][0].answers[index]">
                    <b>Tradução:</b> {{PlaceQuizes[lang][0].answers[index].text}}
                  </p>
                  <answer-translate-form
                    :is-disabled="answerFormLoading[index]"
                    :is-loading="answerFormDisabled[index]"
                    :form-data="{ index }"
                    button-label="Traduzir"
                    :on-submit="saveAnswer"
                    v-else
                  />
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column"><hr /></div>
            </div>
          </div>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QuizForm from './forms/QuizForm'
import AnswerTranslateForm from './forms/AnswerTranslateForm'
export default {
  name: 'QuizTranslator',
  components: { QuizForm, AnswerTranslateForm },
  props: {
    lang: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isMainFormLoading: false,
    isMainFormDisabled: false,
    answerFormLoading: {},
    answerFormDisabled: {}
  }),
  computed: {
    ...mapGetters([
      'PlaceQuizes'
    ])
  },
  methods: {
    ...mapActions(['translateQuiz', 'translateQuizAnswer']),
    async save (data) {
      data.language = this.lang
      const { id } = this.PlaceQuizes['pt'][0]
      const placeId = this.$route.params.id
      // console.log({ data, id, placeId })
      try {
        this.isMainFormLoading = true
        this.isMainFormDisabled = true
        await this.translateQuiz({ data, id, placeId })
        this.isMainFormLoading = false
        this.isMainFormDisabled = false
        this.showQuestion = false
        this.showAnswers = true
        this.$notify.open({
          type: 'success',
          content: 'Desafio traduzido com sucesso!',
          duration: 10000
        })
      } catch (error) {
        console.log(error)
        console.log(error.response)
        this.isMainFormLoading = false
        this.isMainFormDisabled = false
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível traduzir o Desafio.',
          duration: 10000
        })
      }
    },
    async saveAnswer (data) {
      const placeId = this.$route.params.id
      const quizId = this.PlaceQuizes['pt'][0].id
      const { index } = data
      const id = this.PlaceQuizes['pt'][0].answers[index].id
      delete data.index
      data.language = this.lang
      // console.log({data, id, quizId, placeId})
      try {
        this.answerFormLoading[index] = true
        this.answerFormDisabled[index] = true
        await this.translateQuizAnswer({data, id, quizId, placeId})
        this.answerFormLoading[index] = false
        this.$notify.open({
          type: 'success',
          content: 'Resposta do Desafio traduzido com sucesso!',
          duration: 10000
        })
      } catch (error) {
        this.answerFormLoading[index] = false
        this.answerFormDisabled[index] = false
        console.log(error)
        console.log(error.response)
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível traduzir a Resposta do Desafio.',
          duration: 10000
        })
      }
    }
  },
  watch: {
    lang (data) {
      if (data) {
        this.isMainFormLoading = false
        this.isMainFormDisabled = false
        this.answerFormLoading = {}
        this.answerFormDisabled = {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QuizTranslator.vue